import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Field } from 'react-final-form';
import { isRequired } from '../../../utils/validation';
import { Nationality } from '../../../components/nationality';
import { Content } from '../../../infrastructure/content';

const NationalityDropDown = ({ values }) => (
  <Content>
    {({ accountDetailsFormErrorSelect }) => (
      <Field
        name="nationalityOther"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <ConditionalPanel isVisible>
            <GenericFieldWrapper
              name="nationalityOther"
              validationMessage={touched && !!error ? accountDetailsFormErrorSelect : null}
            >
              <Nationality {...input} removeCountries={['British']} values={values} />
            </GenericFieldWrapper>
          </ConditionalPanel>
        )}
      </Field>
    )}
  </Content>
);

export default NationalityDropDown;
